export type ContextSearchMatch = {
  label: string
  excerpt: string
}

type ContextSearchField = {
  label: string
  value?: string | null
}

export function getPlainSearchText(value?: string | null): string {
  return (value ?? "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim()
}

function getMatchExcerpt(text: string, query: string): string {
  const normalizedText = getPlainSearchText(text)
  const index = normalizedText.toLowerCase().indexOf(query.toLowerCase())
  if (index === -1) return normalizedText

  const radius = 42
  const start = Math.max(0, index - radius)
  const end = Math.min(normalizedText.length, index + query.length + radius)
  const prefix = start > 0 ? "..." : ""
  const suffix = end < normalizedText.length ? "..." : ""
  return `${prefix}${normalizedText.slice(start, end)}${suffix}`
}

export function getContextSearchMatch(
  query: string,
  fields: ContextSearchField[]
): ContextSearchMatch | null {
  const normalizedQuery = query.trim().toLowerCase()
  if (!normalizedQuery) return null

  for (const field of fields) {
    const value = getPlainSearchText(field.value)
    if (value.toLowerCase().includes(normalizedQuery)) {
      return {
        label: field.label,
        excerpt: getMatchExcerpt(value, query.trim()),
      }
    }
  }

  return null
}
